/**
 * WhatIsThisTip — an info-icon tooltip used on admin cards and page
 * headers to answer the "what does this do?" question at a glance.
 *
 * Renders as a small circular info icon; hover / focus reveals a native
 * `title` tooltip. Keeps a11y simple by mapping to standard title text.
 *
 * Props:
 *   text     : required tooltip content
 *   className: additional Tailwind classes if the parent needs to nudge
 *              placement (e.g. `ml-auto`, `absolute top-2 right-2`).
 */
import React from 'react';
import { HelpCircle } from 'lucide-react';

const WhatIsThisTip = ({ text, className = '' }) => (
  <span
    role="img"
    aria-label="What is this?"
    title={text}
    className={`inline-flex items-center justify-center h-4 w-4 rounded-full text-muted-foreground hover:text-primary transition-colors cursor-help ${className}`}
    data-testid="what-is-this-tip"
  >
    <HelpCircle className="w-3.5 h-3.5" />
  </span>
);

export default WhatIsThisTip;
